import React, { useState } from "react";
import RenderClientStyle from "./RenderClients.module.css";
import { FaSearch } from "react-icons/fa"; // Font Awesome search icon

const RenderClients = ({ ClientData }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const filteredData = ClientData.filter((user) => {
    return (
      user.username?.toLowerCase().includes(searchQuery) ||
      user.firstName?.toLowerCase().includes(searchQuery) ||
      user.lastName?.toLowerCase().includes(searchQuery) ||
      user.ticketType?.toLowerCase().includes(searchQuery) ||
      user.gender?.toLowerCase().includes(searchQuery) ||
      user.referredBy?.toLowerCase().includes(searchQuery)
    );
  });

  return (
    <div className={RenderClientStyle.TicketStats}>
      <div className={RenderClientStyle.searchContainer}>
        <FaSearch className={RenderClientStyle.searchIcon} />
        <input
          type="text"
          placeholder="Search by Username, First Name, Last Name, Ticket Type, Gender, or Promoter"
          value={searchQuery}
          onChange={handleSearch}
          className={RenderClientStyle.searchInput}
        />
      </div>
      <table className={RenderClientStyle.table}>
        <thead>
          <tr>
            <th>Scanned</th>
            <th>PATT Username</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Ticket Type</th>
            <th>Gender</th>
            <th>Promoter</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((user, index) => (
            <tr key={index}>
              <td>
                <div
                  style={{
                    background: user.hasScanned ? "#06e600" : "white",
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "auto"
                  }}
                ></div>
              </td>
              <td>{user.username ? "@" + user.username : "NOT A USER"}</td>
              <td>{user.firstName}</td>
              <td>{user.lastName}</td>
              <td>{user.ticketType}</td>
              <td
                style={{
                  color: user.gender === "Male" ? "blue" : "#ff748c"
                }}
              >
                {user.gender === "Male" ? "♂" : "♀"}
              </td>
              <td>{user.referredBy}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RenderClients;
